import { GroupWithPot } from 'app/hooks/useGroupsWithPot/types';
import * as yup from 'yup';

export interface TransferPotInfo {
  fromPotName: string;
  toPotName: string;
  points: number;
}

export interface TopUpPotFormProps {
  companyId: string;
  onClose: () => void;
  onSuccess?: (info: TransferPotInfo) => void;
  onError?: (info: TransferPotInfo) => void;
  originGroupWithPot: GroupWithPot;
}

export interface TopUpPotFormFields {
  amount?: string;
  destinationPot?: string;
}

export const createSchema = (maxBalance: number) =>
  yup.object({
    amount: yup
      .string()
      .required('Amount is required')
      .test('is-number', 'Enter a valid number', (value) => {
        const num = parseFloat(value ?? '');
        return !Number.isNaN(num);
      })
      .test('min-balance', 'The amount must be greater than zero.', (value) => {
        const num = parseFloat(value ?? '');
        return !Number.isNaN(num) && num > 0;
      })
      .test('max-balance', 'Amount exceeds Company Wallet available balance', (value) => {
        const num = parseFloat(value ?? '');
        return !Number.isNaN(num) && num <= maxBalance;
      }),
  });

export const DEFAULT_CREATE_POT_FORM_DATA: TopUpPotFormFields = {
  amount: undefined,
};

export const PREDEFINED_AMOUNTS = [
  { label: '5k', value: '5000' },
  { label: '10k', value: '10000' },
  { label: '25k', value: '25000' },
  { label: '50k', value: '50000' },
];
